export default __webpack_public_path__ + "images/p10.jpg";